// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.routine-page-container {
  width: 100%;
  max-width: var(--layout-page-max);
  margin: 0 auto;
  background: transparent;
}

.routine-page {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.routine-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-7);
}

.routine-header-left {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-width: 0;
}

.routine-header-copy {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.routine-back-button {
  flex-shrink: 0;
}

.saving-indicator {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--color-primary-green);
  font-style: italic;
}

.saving-indicator .spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.routine-header-icon {
  font-size: 32px;
}

.routine-tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-6);
  padding-bottom: var(--space-3);
  border-bottom: 1px solid var(--color-border-subtle);
}

.routine-content-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  padding: var(--space-6);
}

/* Tablet and mobile: span full width */
@media (max-width: 1024px) {
  .routine-page-container,
  .routine-page {
    width: 100%;
    margin: 0;
  }
  
  .routine-header {
    margin-bottom: var(--space-6);
  }

  .routine-tabs {
    margin-bottom: var(--space-4);
  }
}

@media (max-width: 768px) {
  .routine-page-container,
  .routine-page {
    padding: 0;
  }
  
  .routine-header {
    margin-bottom: var(--space-4);
  }

  .routine-tabs {
    margin-bottom: var(--space-3);
  }
}

.routine-tab {
  background: none;
  border: none;
  font: inherit;
  color: var(--color-dark-gray);
  font-size: 20px;
  padding: 0 8px 8px 8px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: color 0.2s, border-bottom 0.2s;
}

.routine-tab.active {
  color: var(--color-primary-green);
  border-bottom: 2px solid var(--color-primary-green);
}

.routine-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: var(--color-black);
}

.routine-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

/* Drag and Drop Styles */
.routine-card-wrapper {
  position: relative;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.routine-card-wrapper.dragging {
  opacity: 0.5;
  transform: rotate(2deg) scale(1.02);
  z-index: 1000;
  box-shadow: var(--shadow-md);
}

.routine-card-wrapper.drag-over {
  transform: translateY(4px);
}

.routine-card-wrapper.drag-over::before {
  content: '';
  position: absolute;
  top: -4px;
  left: 0;
  right: 0;
  height: 4px;
  background-color: var(--color-primary-green);
  border-radius: 2px;
  z-index: 1001;
  animation: pulse 1s infinite;
}

.routine-card-wrapper.drag-over::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  right: 0;
  height: 4px;
  background-color: var(--color-primary-green);
  border-radius: 2px;
  z-index: 1001;
  animation: pulse 1s infinite;
}

/* Non-draggable cards (recommendations) */
.routine-card-wrapper.non-draggable {
  opacity: 0.8;
}

.routine-card-wrapper.non-draggable .routine-card-drag-handle {
  opacity: 0.2;
  cursor: not-allowed;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.routine-steps-list {
  margin-top: var(--space-7);
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.routine-steps {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.routine-step {
  display: flex;
  align-items: center;
  gap: var(--space-7);
  background: var(--color-surface);
  border-radius: var(--radius-md);
  padding: var(--space-6) var(--space-7);
  border: 1px solid var(--color-border-subtle);
  box-shadow: none;
}

.routine-step-index {
  width: 32px;
  height: 32px;
  background: var(--accent);
  color: var(--text-on-accent);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--color-light-green);
  display: flex;
  align-items: center;
  justify-content: center;
}

.routine-step-label {
  color: var(--color-primary-green);
  font-size: 18px;
  font-weight: 500;
  min-width: 100px;
}

.routine-step-product {
  flex: 1;
  background: var(--color-surface-muted);
  border-radius: var(--radius-sm);
  padding: 12px 24px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.routine-step-company {
  color: var(--color-dark-gray);
  font-size: 12px;
  letter-spacing: 1px;
}

.routine-step-name {
  color: var(--color-black);
  font-size: 16px;
  font-weight: 500;
}

.recommendations-icon-button {
  background: none !important;
  border: none !important;
  padding: 8px !important;
  color: var(--color-dark-gray) !important;
}

.recommendations-icon-button:hover {
  background-color: var(--color-surface-muted) !important;
  border-radius: 50% !important;
}

/* Recommendations Banner Styles */
.recommendations-banner-container {
  margin: 0px;
}

.recommendations-banner-container:last-child {
  margin-bottom: 0;
}

.routine-explanation-banner {
  margin-bottom: var(--space-4);
}

.routine-explanation-section-block {
  display: block;
}

/* Guest marketing banner (shown above tabs for non-logged-in users) */
.guest-marketing-banner {
  margin-bottom: var(--space-4);
  padding: var(--space-4) var(--space-5);
  border-radius: var(--radius-md);
  background:
    linear-gradient(135deg, var(--accent-soft), var(--accent-softer)),
    var(--surface-2);
  border: 1px solid var(--border-subtle);
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
}

.guest-marketing-banner-text {
  flex: 1;
  min-width: 0;
}

.guest-marketing-banner-title {
  margin-bottom: 4px;
}

.guest-marketing-banner-body {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .guest-marketing-banner {
    flex-direction: column;
    align-items: flex-start;
    padding: 14px 16px;
  }
}

/* Add to Routine Button Styles */
.add-to-routine-button-container {
  display: flex;
  justify-content: center;
  margin-top: var(--space-7);
  padding: var(--space-5) 0;
  border-top: 1px solid var(--color-border-subtle);
}

.add-to-routine-button:hover {
  color: var(--color-dark-green);
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .add-to-routine-button-container {
    margin-top: var(--space-6);
    padding: var(--space-4) 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/RoutinePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iCAAiC;EACjC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE;;IAEE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;EAC/B,sCAAsC;EACtC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,uDAAuD;EACvD,6BAA6B;AAC/B;;AAEA,kCAAkC;AAClC;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,+BAA+B;EAC/B;;oBAEkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;AACF","sourcesContent":[".routine-page-container {\n  width: 100%;\n  max-width: var(--layout-page-max);\n  margin: 0 auto;\n  background: transparent;\n}\n\n.routine-page {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.routine-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-7);\n}\n\n.routine-header-left {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  min-width: 0;\n}\n\n.routine-header-copy {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 0;\n}\n\n.routine-back-button {\n  flex-shrink: 0;\n}\n\n.saving-indicator {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  color: var(--color-primary-green);\n  font-style: italic;\n}\n\n.saving-indicator .spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.routine-header-icon {\n  font-size: 32px;\n}\n\n.routine-tabs {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-6);\n  padding-bottom: var(--space-3);\n  border-bottom: 1px solid var(--color-border-subtle);\n}\n\n.routine-content-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 120px;\n  padding: var(--space-6);\n}\n\n/* Tablet and mobile: span full width */\n@media (max-width: 1024px) {\n  .routine-page-container,\n  .routine-page {\n    width: 100%;\n    margin: 0;\n  }\n  \n  .routine-header {\n    margin-bottom: var(--space-6);\n  }\n\n  .routine-tabs {\n    margin-bottom: var(--space-4);\n  }\n}\n\n@media (max-width: 768px) {\n  .routine-page-container,\n  .routine-page {\n    padding: 0;\n  }\n  \n  .routine-header {\n    margin-bottom: var(--space-4);\n  }\n\n  .routine-tabs {\n    margin-bottom: var(--space-3);\n  }\n}\n\n.routine-tab {\n  background: none;\n  border: none;\n  font: inherit;\n  color: var(--color-dark-gray);\n  font-size: 20px;\n  padding: 0 8px 8px 8px;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: color 0.2s, border-bottom 0.2s;\n}\n\n.routine-tab.active {\n  color: var(--color-primary-green);\n  border-bottom: 2px solid var(--color-primary-green);\n}\n\n.routine-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  color: var(--color-black);\n}\n\n.routine-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n/* Drag and Drop Styles */\n.routine-card-wrapper {\n  position: relative;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.routine-card-wrapper.dragging {\n  opacity: 0.5;\n  transform: rotate(2deg) scale(1.02);\n  z-index: 1000;\n  box-shadow: var(--shadow-md);\n}\n\n.routine-card-wrapper.drag-over {\n  transform: translateY(4px);\n}\n\n.routine-card-wrapper.drag-over::before {\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background-color: var(--color-primary-green);\n  border-radius: 2px;\n  z-index: 1001;\n  animation: pulse 1s infinite;\n}\n\n.routine-card-wrapper.drag-over::after {\n  content: '';\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background-color: var(--color-primary-green);\n  border-radius: 2px;\n  z-index: 1001;\n  animation: pulse 1s infinite;\n}\n\n/* Non-draggable cards (recommendations) */\n.routine-card-wrapper.non-draggable {\n  opacity: 0.8;\n}\n\n.routine-card-wrapper.non-draggable .routine-card-drag-handle {\n  opacity: 0.2;\n  cursor: not-allowed;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n.routine-steps-list {\n  margin-top: var(--space-7);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n.routine-steps {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n.routine-step {\n  display: flex;\n  align-items: center;\n  gap: var(--space-7);\n  background: var(--color-surface);\n  border-radius: var(--radius-md);\n  padding: var(--space-6) var(--space-7);\n  border: 1px solid var(--color-border-subtle);\n  box-shadow: none;\n}\n\n.routine-step-index {\n  width: 32px;\n  height: 32px;\n  background: var(--accent);\n  color: var(--text-on-accent);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.step-number {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: var(--color-light-green);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.routine-step-label {\n  color: var(--color-primary-green);\n  font-size: 18px;\n  font-weight: 500;\n  min-width: 100px;\n}\n\n.routine-step-product {\n  flex: 1;\n  background: var(--color-surface-muted);\n  border-radius: var(--radius-sm);\n  padding: 12px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.routine-step-company {\n  color: var(--color-dark-gray);\n  font-size: 12px;\n  letter-spacing: 1px;\n}\n\n.routine-step-name {\n  color: var(--color-black);\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.recommendations-icon-button {\n  background: none !important;\n  border: none !important;\n  padding: 8px !important;\n  color: var(--color-dark-gray) !important;\n}\n\n.recommendations-icon-button:hover {\n  background-color: var(--color-surface-muted) !important;\n  border-radius: 50% !important;\n}\n\n/* Recommendations Banner Styles */\n.recommendations-banner-container {\n  margin: 0px;\n}\n\n.recommendations-banner-container:last-child {\n  margin-bottom: 0;\n}\n\n.routine-explanation-banner {\n  margin-bottom: var(--space-4);\n}\n\n.routine-explanation-section-block {\n  display: block;\n}\n\n/* Guest marketing banner (shown above tabs for non-logged-in users) */\n.guest-marketing-banner {\n  margin-bottom: var(--space-4);\n  padding: var(--space-4) var(--space-5);\n  border-radius: var(--radius-md);\n  background:\n    linear-gradient(135deg, var(--accent-soft), var(--accent-softer)),\n    var(--surface-2);\n  border: 1px solid var(--border-subtle);\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n}\n\n.guest-marketing-banner-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.guest-marketing-banner-title {\n  margin-bottom: 4px;\n}\n\n.guest-marketing-banner-body {\n  opacity: 0.9;\n}\n\n@media (max-width: 768px) {\n  .guest-marketing-banner {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 14px 16px;\n  }\n}\n\n/* Add to Routine Button Styles */\n.add-to-routine-button-container {\n  display: flex;\n  justify-content: center;\n  margin-top: var(--space-7);\n  padding: var(--space-5) 0;\n  border-top: 1px solid var(--color-border-subtle);\n}\n\n.add-to-routine-button:hover {\n  color: var(--color-dark-green);\n  transform: translateY(-1px);\n}\n\n@media (max-width: 768px) {\n  .add-to-routine-button-container {\n    margin-top: var(--space-6);\n    padding: var(--space-4) 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
